import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Summary from 'pages/Main/Insights/Summary';
import Sales from 'pages/Main/Insights/Sales';
import Payment from 'pages/Main/Insights/Payment';
// import Promos from 'pages/Main/Insights/Promos';

import BrandSelect from 'components/Form/BrandSelect';
import { Container, Header, Tabs, Tab, Filters } from './styles';
import useConnect from './connect';

const Insights: FC = () => {
  const { selectedBrandId, setSelectedBrandId } = useConnect();

  return (
    <Container>
      <Header>
        <Tabs>
          <Tab label="Summary" to="/insights/summary" />
          <Tab label="Sales" to="/insights/sales" />
          {/* <Tab
            style={{ marginRight: '1rem' }}
            label="Promos"
            to="/insights/promos"
          /> */}
          <Tab label="Payment" to="/insights/payment" />
        </Tabs>

        <Filters>
          <BrandSelect
            setSelectedId={setSelectedBrandId}
            value={selectedBrandId}
            allowAllOption={false}
          />
        </Filters>
      </Header>
      <Switch>
        <Route exact path="/insights/summary">
          <Summary brandId={selectedBrandId} />
        </Route>
        <Route exact path="/insights/sales">
          <Sales brandId={selectedBrandId} />
        </Route>
        <Route exact path="/insights/payment">
          <Payment brandId={selectedBrandId} />
        </Route>
        {/* <Route exact path="/insights/promos">
          <Promos brandId={selectedBrandId} />
        </Route> */}

        <Redirect to="/insights/summary" />
      </Switch>
    </Container>
  );
};

export default Insights;
